import { httpsCallable } from 'firebase/functions';
import { functions } from "../../firebase";

export const convertAudioToMP3 = httpsCallable(functions, 'audioToMp3');
export const exerciseTextToAudio = httpsCallable(functions, 'exerciseTextToAudio');
export const ttsGenerate = httpsCallable(functions, 'ttsGenerate');
export const generateCraftedAudioOnCall = httpsCallable(functions, 'generateCraftedAudioOnCall');